import { fetchSchools, fetchSchool, editSchool } from "./asyncThunks";

export const fetchingSchoolsReducerBuilder = (builder) => {
  builder.addCase(fetchSchools.pending, (state, action) => {
    state.loading = true;
  });
  builder.addCase(fetchSchools.fulfilled, (state, action) => {
    state.schools = action.payload;
    state.loading = false;
  });
  builder.addCase(fetchSchools.rejected, (state, action) => {
    state.loading = false;
  });
};

export const fetchingSchoolReducerBuilder = (builder) => {
  builder.addCase(fetchSchool.pending, (state, action) => {
    state.loading = true;
  });
  builder.addCase(fetchSchool.fulfilled, (state, action) => {
    state.schoolData = action.payload;
    state.loading = false;
  });
  builder.addCase(fetchSchool.rejected, (state, action) => {
    state.loading = false;
  });
};

export const editingSchoolReducerBuilder = (builder) => {
  builder.addCase(editSchool.pending, (state, action) => {
    state.editSchoolPending = true;
  });
  builder.addCase(editSchool.fulfilled, (state, action) => {
    state.schoolData = action.payload;
    state.editSchoolPending = false;
  });
  builder.addCase(editSchool.rejected, (state, action) => {
    state.editSchoolPending = false;
  });
};
